import { Formik } from 'formik'
import { noop } from 'lodash'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import {
  SemiConfigFormValues,
  getInitialValuesBasedOnProduct,
  useProductFromQueryParam,
} from './ProductsConfiguration'
import FormikLocalStorage from '@src/routes/Configurators/products/TubesMTORedesign/FormikLocalStorage'
import SemiConfiguratorLayout from './SemiConfiguratorLayout'

const SemiConfigurator = () => {
  const product = useProductFromQueryParam()
  const initialValues = getInitialValuesBasedOnProduct(product)
  return (
    <DefaultLayout spacing={LayoutSpacingOptions.SM}>
      <Formik<SemiConfigFormValues>
        initialValues={initialValues}
        onSubmit={noop}
        validateOnChange={false}
        validateOnBlur={false}
      >
        <FormikLocalStorage semiConfigProduct>
          <SemiConfiguratorLayout />
        </FormikLocalStorage>
      </Formik>
    </DefaultLayout>
  )
}

export default SemiConfigurator
